export const CONSTANTS = {
    SHAKTI_CLOUD_URL: "https://sosnm1.shakticloud.ai:9024/",
    MEDIA_EROS_URL: "https://media.erosuniverse.com/",
};
